<template>
  <v-container fluid>
    <!-- <v-row class="py-5">
      <v-col cols="12" sm="6">
        <quicksearch v-model="ticketsearch" :immediate="true"></quicksearch>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          label="Status"
          :items="statusItems"
          v-model="status"
          outlined dense hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          label="Categoria"
          :items="categoryItems"
          v-model="category"
          multiple chips
          outlined dense hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          label="Tag Heppi"
          :items="tagItems"
          v-model="tag"
          multiple chips
          outlined dense hide-details
        ></v-autocomplete>
      </v-col>
    </v-row> -->
    <v-card outlined elevation="0">
      <div v-if="!loading && chatIDs && chatIDs.length === 0" class="pa-2 text-center">Nenhum ID do huggy configurado</div>
      <div v-else-if="!loading && lastTickets.length === 0" class="pa-2 text-center">Nenhuma conversa para o filtro solicitado</div>
      <v-list v-else class="pb-0 pt-0">
        <v-list-item v-if="!loading">
          <v-list-item-content>
            <v-list-item-subtitle class="text-right">Mostrando {{ lastTickets.length === 100 ? 'as últimas 20 conversas' : lastTickets.length === 1 ? '1 conversa' : `${lastTickets.length} conversas` }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="!loading" />
        <template v-for="(item, index) in lastTickets">
          <v-divider v-if="index > 0" :key="'support=divider-' + index" />
          <v-list-item two-line :key="'support-item-' + index" @click="openChatDetails(item)">
            <v-list-item-content>
              <v-list-item-title>#<b>{{ item.id }}</b> <v-chip x-small class="ml-2" label :color="statusColor[item.situation] || 'grey-3'">{{ statusInfo[item.situation] || item.situation }}</v-chip></v-list-item-title>
              <v-list-item-subtitle>{{ item.createdAt | moment('DD/MM/YYYY hh:mm') }} | {{ (item.chatTabulation && item.chatTabulation.name) || 'Sem classificação ainda' }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
        <v-divider v-if="loading" />
        <v-list-item v-if="loading">
          <v-list-item-content>
            <v-list-item-title class="text-center">Carregando...</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <huggy-details-dialog :openedChat="openedChat" @close="openedChat = null" />
  </v-container>
</template>

<script>
import axios from 'axios'
// import Quicksearch from '@/components/Quicksearch'
import HuggyDetailsDialog from '@/components/HuggyDetailsDialog'

export default {
  name: 'TicketTabList',
  components: {
    // Quicksearch,
    HuggyDetailsDialog
  },
  props: {
    id: {
      type: String,
      default: null
    },
    customerID: {
      type: String,
      default: null
    },
    reference: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      loading: false,
      // ticketsearch: '',
      // status: '',
      // category: [],
      // tag: [],
      lastTickets: [],
      chatIDs: [],
      openedChat: null,
      timeoutTicketGet: null
      // participants: []
    }
  },
  computed: {
    statusInfo () {
      return {
        auto: 'Agente Virtual',
        in_chat: 'Em atendimento',
        wait_for_chat: 'Na fila',
        blocked: 'Bloqueado',
        finishing: 'Encerrado',
        finished: 'Encerrado',
        filed: 'Arquivado'
      }
    },
    statusColor () {
      return {
        auto: 'primary',
        in_chat: 'primary',
        wait_for_chat: 'secondary',
        blocked: 'error',
        finishing: 'success',
        finished: 'success',
        filed: 'grey-3'
      }
    }
  },
  methods: {
    openChatDetails (item) {
      this.openedChat = item
    },
    async getCustomerChatID (id) {
      try {
        const { data } = await axios.get(`customers/${id}`)
        return (data && data.chat_ids) || []
      } catch (error) {
        return false
      }
    },
    async getTickets (refresh) {
      this.loading = true
      if (refresh) this.lastTickets = []
      if (this.chatIDs && this.chatIDs[0]) {
        try {
          const chats = await this.$store.dispatch('huggyApi', { method: 'GET', url: 'chats', params: { customer: this.chatIDs[0] } })
          this.lastTickets = [...this.lastTickets, ...chats]
        } catch (error) {
          console.log('problema no get', error)
        }
      }
      this.loading = false
    }
  },
  async mounted () {
    this.loading = true
    if (this.customerID) {
      const chatIDs = await this.getCustomerChatID(this.customerID) || []
      console.log(this.chatIDs, chatIDs)
      this.chatIDs = [...this.chatIDs, ...chatIDs]
    }
    this.getTickets(true)
  }
}
</script>
